import { LatestpayScale } from '../../../api/pcr-pay-scale/get-latest-pcr-pay-scale'
import { StaffApplicationStatusEnum } from '../../../lib/types/enums/staff-application/staff-application-status.enum'
import { StaffApplication } from '../../../lib/types/models/staff-application/staff-application'

export const formatPcrSalary = (amount?: number | null) =>
  amount !== undefined && amount !== null ? `${amount} €` : '-'

export const getPcrSalaryByStatus = (
  status: StaffApplicationStatusEnum,
  payScale?: LatestpayScale
) => {
  if (status === StaffApplicationStatusEnum.CLASSIFIED) return payScale?.classifiedAmount ?? 0
  // ACCEPTED and REJECTED_AFTER_INTERVIEW went through the interview, so the PCR is still
  // owed the interview amount until the application is paid
  if (
    status === StaffApplicationStatusEnum.INTERVIEW_DONE ||
    status === StaffApplicationStatusEnum.ACCEPTED ||
    status === StaffApplicationStatusEnum.REJECTED_AFTER_INTERVIEW
  )
    return payScale?.interviewDoneAmount ?? 0
  return null
}

export const getPcrApplicationSalary = (
  application: Pick<StaffApplication, 'status' | 'pcrScoreCard'>,
  payScale?: LatestpayScale
) =>
  application.pcrScoreCard?.paidToPCR
    ? (application.pcrScoreCard.amountPaidToPCR ?? null)
    : getPcrSalaryByStatus(application.status, payScale)
